import axios from 'axios'
const instance = axios.create({
  baseURL:"https://jxxcx.iyayou.top/"
})

export default instance